import React from 'react';
import {Popup} from 'components';

export function PriorityPopup({ value, setValue }) {
  return (
    <Popup.Menu>
      <Popup.Menu.Item pressed={value === 'High'} onClick={() => setValue('High')}>High</Popup.Menu.Item>
      <Popup.Menu.Item pressed={value === 'Medium'} onClick={() => setValue('Medium')}>Medium</Popup.Menu.Item>
      <Popup.Menu.Item pressed={value === 'Low'} onClick={() => setValue('Low')}>Low</Popup.Menu.Item>
      <Popup.Menu.Item pressed={!value} onClick={() => setValue('')}>None</Popup.Menu.Item>
    </Popup.Menu>
  );
}
